import { combineReducers } from 'redux';
import { userReducer } from './user/reducer';
import { uiReducer } from './ui/reducer';
import { lawsCategoriesReducer } from './lawsCategories/reducer';
// import { newsCategoriesReducer } from './newsCategories/reducer';
import { newsDigestsCategoriesReducer } from './newsDigestsCategories/reducer';
import { lawsSourcesReducer } from './lawsSources/reducer';
import { lawsDoctypesReducer } from './lawsDoctypes/reducer';
import { lawsThemesReducer } from './lawsThemes/reducer';
// import { Reducer } from './lawsAllPublicationsFilters/reducer';
import { AllFOIVCategoriesReducer } from './AllFOIVCategories/reducer';
import { FOIVBigSubCategoriesReducer } from './FOIVBigSubCategories/reducer';
import { FOIVSmallSubCategoriesReducer } from './FOIVSmallSubCategories/reducer';
import { AllFOIVThemesReducer } from './AllFOIVThemes/reducer';
import { FOIVBigSubThemesReducer } from './FOIVBigSubThemes/reducer';
import { FOIVSmallSubThemesReducer } from './FOIVSmallSubThemes/reducer';
import { activeFeedReducer } from './activeFeed/reducer';

import { allNewsReducer } from './allNews/reducer';
import { favoriteNewsReducer } from './favoriteNews/reducer';
import { allNewsFiltersReducer } from './allNewsFilters/reducer';
import { favoriteNewsFiltersReducer } from './favoriteNewsFilters/reducer';

import { unitedCardPNDReducer } from './unitedCardPND/reducer';

import { categoriesReducer } from './categories/reducer';
import { additionalReducer } from './additional/reducer';

import { lawsAllPublicationsReducer } from './lawsAllPublications/reducer';
import { lawsMyFavoritesReducer } from './lawsMyFavorites/reducer';
import { lawsMyActionsReducer } from './lawsMyActions/reducer';
import { lawsWaitingReducer } from './lawsWaiting/reducer';

import { lawsAllPublicationsFiltersReducer } from './lawsAllPublicationsFilters/reducer';
import { lawsMyFavoritesFiltersReducer } from './lawsMyFavoritesFilters/reducer';
import { lawsMyActionsFiltersReducer } from './lawsMyActionsFilters/reducer';
import { lawsWaitingFiltersReducer } from './lawsWaitingFilters/reducer';

import { digestsReducer } from './digests/reducer';
import { digestsDisplayReducer } from './digestsDisplay/reducer';
import { digestsSuggestionsReducer } from './digestsSuggestions/reducer';

import { newsDigestsReducer } from './newsDigests/reducer';
import { newsDigestsDisplayReducer } from './newsDigestsDisplay/reducer';
import { newsDigestsSuggestionsReducer } from './newsDigestsSuggestions/reducer';

import { savedScrollsReducer } from './savedScrolls/reducer';

const rootReducer = combineReducers({
    ui: uiReducer,
    user: userReducer,
    activeFeedData: activeFeedReducer,

    lawsCategories: lawsCategoriesReducer,
    // newsCategories: newsCategoriesReducer,
    newsDigestsCategories: newsDigestsCategoriesReducer,
    AllFOIVCategories: AllFOIVCategoriesReducer,
    AllFOIVThemes: AllFOIVThemesReducer,
    FOIVBigSubCategories: FOIVBigSubCategoriesReducer,
    FOIVBigSubThemes: FOIVBigSubThemesReducer,
    FOIVSmallSubCategories: FOIVSmallSubCategoriesReducer,
    FOIVSmallSubThemes: FOIVSmallSubThemesReducer,
    lawsThemes: lawsThemesReducer,
    lawsSources: lawsSourcesReducer,
    lawsDoctypes: lawsDoctypesReducer,
    unitedCardPND: unitedCardPNDReducer,

    categories: categoriesReducer,
    additional: additionalReducer, 

    lawsAllPublications: lawsAllPublicationsReducer,
    lawsMyFavorites: lawsMyFavoritesReducer,
    lawsMyActions: lawsMyActionsReducer,
    lawsWaiting: lawsWaitingReducer,

    allNews: allNewsReducer,
    favoriteNews: favoriteNewsReducer,

    lawsAllPublicationsFilters: lawsAllPublicationsFiltersReducer,
    lawsMyFavoritesFilters: lawsMyFavoritesFiltersReducer,
    lawsMyActionsFilters: lawsMyActionsFiltersReducer,
    lawsWaitingFilters: lawsWaitingFiltersReducer,

    digests: digestsReducer,
    digestsDisplay: digestsDisplayReducer,
    digestsSuggestions: digestsSuggestionsReducer,

    newsDigests: newsDigestsReducer,
    newsDigestsDisplay: newsDigestsDisplayReducer,
    newsDigestsSuggestions: newsDigestsSuggestionsReducer,

    allNewsFilters: allNewsFiltersReducer,
    favoriteNewsFilters: favoriteNewsFiltersReducer,

    savedScrolls: savedScrollsReducer,
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/redux_related/rootReducer.js